export default __webpack_public_path__ + "static/media/010_home.vp9.2de4f35f.webm";